import { Directive, HostListener } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';

@Directive({
  selector: '[ktBackButton]',
})
export class BackButtonDirective {
  constructor(private navigationService: NavigationService) {}

  @HostListener('click')
  onClick() {
    this.navigationService.goBack();
  }
}
